import React, { useState } from "react"
import { Grid, Form, Button } from "semantic-ui-react"
import "./ConfirmProposalRequestYtd.css"
import { LabeledInput, FormContainer, InputField, StandardModal } from "uikit"
import { accountTypes } from "components/accounts/accountTypes"
import { useStore } from "store"

const contributionAccountTypes = Object.keys(accountTypes)
  .filter(accountType => accountTypes[accountType].askYtd === true)
  .map(accountType => accountType)

const ConfirmProposalRequestYtd = props => {
  const { scenario, household, requestProposal } = props
  const [accountsObject, { updateAccount }] = useStore(
    "householdAccounts",
    household.id
  )
  const [loading, setLoading] = useState(false)
  const onCancel = () => props.onNo()
  const onRequestProposal = async () => {
    const response = await requestProposal(scenario.id, {
      base_date: new Date().toISOString().substring(0, 10)
    })
    if (response.error) {
      props.onConflict()
    } else {
      props.onYes()
    }
    setLoading(false)
  }

  const accounts = Object.values(accountsObject)
  const accountList = Object.values(accounts)
    .filter(
      account =>
        account.contributions_ytd >= 0 &&
        contributionAccountTypes.includes(account.type)
    )
    .map(account => ({
      id: account.id,
      type: account.type,
      contributions_ytd: account.contributions_ytd,
      name: account.name
    }))
  const contributionAccounts = accountList.map(account => {
    return {
      id: account.id,
      type: account.type,
      contributions_ytd: account.contributions_ytd
    }
  })

  const values = Object.assign(
    {},
    { contributionAccounts: contributionAccounts }
  )
  return (
    <ContributionsYtdModal
      values={values}
      accountList={accountList}
      onCancel={onCancel}
      forceModified={true}
      loading={loading}
      submit={async ({ contributionAccounts }) => {
        if (loading) return
        setLoading(true)
        await Promise.all(
          contributionAccounts.map(({ id, type, contributions_ytd }) => {
            return updateAccount({ id, type, contributions_ytd })
          })
        )
        await onRequestProposal()
      }}
    />
  )
}

const ContributionsYtdFormSchema = {
  contributionAccounts: {
    type: "array",
    schema: {
      id: {
        type: "string"
      },
      type: {
        type: "string"
      },
      contributions_ytd: {
        type: "unit",
        defaultValue: 0
      }
    }
  }
}

const ContributionsYtdForm = ({
  data: {
    fields: { contributionAccounts },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  accountList
}) => {
  const [showAllAccounts, setShowAllAccounts] = useState(false)
  return (
    <Form error={hasError} loading={isPending} className="AddModal__Form">
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <p>
              Have you contributed to your qualified acccounts this year? If you
              know how much, please enter amounts values here so we can take
              those contributions into account when considering your
              contribution limits.
            </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="accountTable">
          <Grid.Column width={16} textAlign="left" verticalAlign="middle">
            <Grid stackable={false}>
              <Grid.Row columns={2} className="accountHeader">
                <Grid.Column
                  textAlign="left"
                  verticalAlign="middle"
                  className="accountTitle"
                >
                  ACCOUNT
                </Grid.Column>
                <Grid.Column
                  textAlign="left"
                  verticalAlign="middle"
                  className="accountSubTitle"
                >
                  YEAR-TO-DATE AMOUNT
                </Grid.Column>
              </Grid.Row>
              {contributionAccounts.array
                .filter(acc => {
                  if (showAllAccounts) {
                    return acc
                  }
                  return acc.fields.contributions_ytd.value !== "0"
                })
                .map(function(account, index) {
                  const accountName = accountList.find(
                    x => x.id === account.fields.id.value
                  ).name
                  return (
                    <Grid.Row
                      key={account.fields.id.value}
                      columns={2}
                      className="accountRow"
                    >
                      <Grid.Column
                        textAlign="left"
                        verticalAlign="middle"
                        className="accountNameCol"
                      >
                        {accountName}
                      </Grid.Column>
                      <Grid.Column className="lighter-blue accountValueCol">
                        <InputField
                          field={account.fields.contributions_ytd}
                          label=""
                          className="AddModal__FormField LabeledInput"
                          control={LabeledInput}
                          iconText="$"
                          iconPosition="left"
                          placeholder="0"
                          textPosition="left"
                        />
                      </Grid.Column>
                    </Grid.Row>
                  )
                })}
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="center" verticalAlign="middle">
            <Button
              content={
                showAllAccounts ? "Hide new accounts" : "Show all accounts"
              }
              type="button"
              onClick={() => setShowAllAccounts(!showAllAccounts)}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  )
}

const ContributionsYtdFormModal = props => (
  <StandardModal wide defaultOpen={true}>
    <StandardModal.Header header="Ready to create your action plan?" />
    <StandardModal.Content>
      {props.accountList.length > 0 ? (
        <ContributionsYtdForm {...props} />
      ) : (
        <div>
          <p>
            You don’t have any qualified accounts, be sure you’ve added your
            retirement accounts.
          </p>
        </div>
      )}
    </StandardModal.Content>
    <StandardModal.Actions
      submitLabel="Create Action Plan"
      cancelLabel="Cancel"
      onSubmit={props.data.onSubmit}
      onCancel={props.onCancel}
      loading={props.loading}
    />
  </StandardModal>
)

const ContributionsYtdModal = FormContainer(
  ContributionsYtdFormSchema,
  (fields, ...form) => {}
)(ContributionsYtdFormModal)

export default ConfirmProposalRequestYtd
